import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./theme/halloween.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import rootreducer from "./reducer";
import { initSentry } from "./sentry";
import AppErrorBoundary from "./components/AppErrorBoundary";
// Build-time branch lets webpack omit local controls from the release.
const SeasonalPreview = process.env.REACT_APP_HALLOWEEN_PREVIEW === "true"
  ? React.lazy(() => import("./theme/SeasonalPreview"))
  : null;

initSentry();

const queryClient = new QueryClient();

const store = configureStore({
  reducer: rootreducer,
});
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const basename = process.env.PUBLIC_URL
  ? new URL(process.env.PUBLIC_URL, window.location.origin).pathname || "/"
  : "/";
root.render(
  <React.StrictMode>
    {/* @ts-ignore */}
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={basename}>
          <AppErrorBoundary>
            {SeasonalPreview && <React.Suspense fallback={null}><SeasonalPreview /></React.Suspense>}
            <App />
          </AppErrorBoundary>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
